import React from "react";
import RegistryPage from "../components/RegistryPage";
import { StatusBadge } from "../components/Badges";

export default function Grievances() {
  return (
    <RegistryPage
      title="Grievance Workbench"
      description="Track and resolve grievances raised by Data Principals under DPDP."
      endpoint="/grievances"
      testIdPrefix="grievances"
      reportKey="grievances"
      columns={[
        { key: "category", label: "Category" },
        { key: "principal_name", label: "Principal" },
        { key: "status", label: "Status", width: "120px", render: (i) => <StatusBadge status={i.status} /> },
        { key: "escalated", label: "Escalated", width: "100px" },
        { key: "due_by", label: "Due by", width: "120px", render: (i) => (i.due_by || "").slice(0,10) },
      ]}
      fields={[
        { key: "principal_name", label: "Principal name" },
        { key: "principal_id", label: "Principal ID" },
        { key: "category", label: "Category", type: "select", options: ["general","consent","access","erasure","accuracy","security","other"] },
        { key: "description", label: "Description", type: "textarea", full: true, required: true },
        { key: "assigned_to", label: "Assigned to" },
        { key: "investigation_notes", label: "Investigation notes", type: "textarea", full: true },
        { key: "resolution", label: "Resolution", type: "textarea", full: true },
        { key: "response", label: "Response to principal", type: "textarea", full: true },
        { key: "escalated", label: "Escalated", type: "checkbox" },
        { key: "status", label: "Status", type: "select", options: ["open","in_progress","resolved","closed"] },
        { key: "due_by", label: "Due by (ISO)" },
      ]}
      defaultItem={{ category: "general", status: "open", escalated: false }}
    />
  );
}
